import React from 'react';
import { useLocation, useParams } from 'react-router';
import {
  HeaderBarLinkSection,
  HeaderBarUserSection,
  useApi,
  CookieUtil,
} from '@axiom/ui';
import { AccountConst } from '@axiom/const';

import { SharedHeaderMenus } from '../../components/SharedHeader/SharedHeaderMenus';
import { QueryParamUtil } from '../../utils/query-param-util';
import { isClientUser, isLpUser } from '../../utils/roles-util';
import { AccountLegacyApi } from '../../api/account-legacy-api';
import { StartEngagementButton } from '../../components/StartEngagementButton/StartEngagementButton';
import { UserApi } from '../../api/user-api';

import { AuthenticatedHeaderMenuItem } from './AuthenticatedHeaderMenuItem';

export type AuthenticatedHeaderMenuProps = {
  hideNavigation?: boolean;
  name?: string;
};

export const AuthenticatedHeaderMenu = ({
  hideNavigation = false,
}: AuthenticatedHeaderMenuProps) => {
  const { accountId: pathParamAccountId } = useParams();
  const location = useLocation();
  const { accountId: queryParamAccountId } = QueryParamUtil.getQueryParams();
  const hasUserCookie = CookieUtil.hasUserCookie() || null;
  const [{ data: user } = { data: undefined }] = useApi(
    hasUserCookie ? UserApi.readUser() : undefined
  );

  const contact = user?.contact;

  const accountId = pathParamAccountId ?? queryParamAccountId;
  const account = (() => {
    let acc;

    if (!contact?.accounts?.length) {
      return null;
    }

    if (accountId) {
      acc = contact.accounts.find(a => a.id === accountId) || null;
    } else {
      [acc] = contact.accounts;
    }

    return acc;
  })();

  const calculatedAccountId = accountId ?? account?.id;

  const [{ data: acc } = { data: undefined }] = useApi(
    calculatedAccountId && user
      ? AccountLegacyApi.readAccount(calculatedAccountId, {
          expand: [AccountConst.Expansions.accountTeamUserInfo],
        })
      : undefined
  );
  const overrideTabs = ['my-engagements', 'my-bench'];

  if (!user) {
    return null;
  }
  return (
    <>
      {!hideNavigation && (
        <HeaderBarLinkSection name="AUTHENTICATED_HEADER_LINK_SECTION">
          {isClientUser(user) && (
            <AuthenticatedHeaderMenuItem
              name="NAVBAR_MY_AXIOM"
              url={`/account/${calculatedAccountId}`}
              overrideSelect={overrideTabs.includes(
                location.pathname.split('/').pop()
              )}
            >
              My Axiom
            </AuthenticatedHeaderMenuItem>
          )}
          {isClientUser(user) && (
            <AuthenticatedHeaderMenuItem
              name="NAVBAR_MY_AXIOM_ENGAGEMENTS"
              url={`/account/${calculatedAccountId}/my-engagements`}
              secondaryMatchSlug="my-engagements"
            >
              My Engagements
            </AuthenticatedHeaderMenuItem>
          )}
          {isClientUser(user) && !!account && (
            <AuthenticatedHeaderMenuItem
              name="NAVBARBENCH"
              url={`/account/${calculatedAccountId}/my-bench`}
              secondaryMatchSlug="my-bench"
            >
              My Bench
            </AuthenticatedHeaderMenuItem>
          )}
          <AuthenticatedHeaderMenuItem
            name="NAVBAR_BROWSE_TALENT"
            url="/browse-talent"
          >
            Browse Talent
          </AuthenticatedHeaderMenuItem>
          {!isLpUser(user) && (
            <StartEngagementButton
              name="NEW_ENGAGEMENT"
              account={acc}
              user={user}
              pattern="brand"
              variation="filled"
            >
              New Engagement
            </StartEngagementButton>
          )}
        </HeaderBarLinkSection>
      )}
      <HeaderBarUserSection name="AUTHENTICATED_HEADER_USER_SECTION">
        <SharedHeaderMenus />
      </HeaderBarUserSection>
    </>
  );
};
